import React from 'react';
import { FaComments, FaChalkboardTeacher } from 'react-icons/fa';
import ContentContainer from '../components/common/ContentContainer';
import Layout from '../components/Layout';
import SEO from '../components/Seo';
import GeneralInquiryForm from '../components/GeneralInquiryForm';

const Contact = () => {
  const [selection, setSelection] = React.useState<
    'general' | 'professional' | null
  >(null);

  const renderChooser = () => (
    <div className="text-center my-10">
      <h1 className="text-2xl sm:text-3xl font-bold mb-6">
        What are you inquiring about today?
      </h1>
      <p className="text-gray-600 text-lg mb-8">
        Let us know about your request so we can connect you to the appropriate
        team member.
      </p>
      <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
        <button
          onClick={() => setSelection('general')}
          className="bg-white shadow-md sans-serif w-full sm:w-[360px] px-8 py-10 rounded-xl border border-gray-300 hover:border-primary hover:shadow-md transition flex items-center justify-center gap-3 text-left"
        >
          <FaComments className="text-primary text-3xl" aria-hidden="true" />
          <div>
            <div className="text-xl font-semibold sans-serif">
              General Inquiries
            </div>
            <div className="text-gray-600 sans-serif">
              Questions not related to professional development
            </div>
          </div>
        </button>
        <button
          onClick={() => setSelection('professional')}
          className="bg-white shadow-md sans-serif w-full sm:w-[360px] px-8 py-10 rounded-xl border border-gray-300 hover:border-primary hover:shadow-md transition flex items-center justify-center gap-3 text-left"
        >
          <FaChalkboardTeacher
            className="text-primary text-3xl"
            aria-hidden="true"
          />
          <div>
            <div className="text-xl font-semibold sans-serif">
              Professional Development Services
            </div>
            <div className="text-gray-600 sans-serif">
              Coaching, institutes, or PD for your school/district
            </div>
          </div>
        </button>
      </div>
    </div>
  );

  // general form moved to its own component to avoid conditional hooks

  const renderPDForm = () => (
    <iframe
      src={'https://app.hellobonsai.com/f/7c10e391efea5c0?embed=true'}
      frameBorder="0"
      width="100%"
      height="1800px"
      title="Professional Development Services Contact Form"
    ></iframe>
  );

  return (
    <Layout>
      <SEO title="Contact" />
      <ContentContainer>
        {selection === null ? (
          renderChooser()
        ) : (
          <div className="my-6">
            <div className="max-w-3xl mx-auto">
              <button
                className="text-primary underline mb-6"
                onClick={() => setSelection(null)}
              >
                &lt; Back
              </button>
            </div>
            {selection === 'professional' ? (
              <div className="max-w-3xl mx-auto">{renderPDForm()}</div>
            ) : (
              <GeneralInquiryForm />
            )}
          </div>
        )}
      </ContentContainer>
    </Layout>
  );
};

export default Contact;
